import { object, string } from 'yup';

export const IAddressNullableSchema = object({
  street: string().trim().optional().nullable(),
  number: string()
    .trim()
    .matches(/^\d+(\s?\w+)?$/)
    .optional()
    .nullable(),
  zipCode: string().trim().optional().nullable(),
  city: string().trim().optional().nullable(),
});

export type IAddressNullable = {
  street: string | null;
  number: string | null;
  zipCode: string | null;
  city: string | null;
};

export type IAddressNullableInput = Partial<IAddressNullable>;
